import { init, createId } from '@paralleldrive/cuid2'

const createSlug = init({
  length: 5,
})

type Options = {
  slug?: boolean
}

export function useCuid(options?: Options) {
  const id = options?.slug ? createSlug() : createId()
  return id
}
